import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Toast } from 'react-vant';
import { apiClientSavePhoto, apigetOrderPhotoH5, apiOssUpload } from '../api';
import AppBar from '../components/appBar';
import Loading from '../components/loading';
import Page from '../components/page';
import ProtocolDialog from '../components/protocolDialog';
import MCheckbox from '../components/radioBox';
import ViewPictureDialog from '../components/viewPictureDialog';
import { Order } from '../types';
import { parseLocationParams, showToast } from '../utils/utils';

export default function SupCertificatesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [detailData, setdetailData] = useState<Order>();
  // 上传照片显示loading
  const [uploadLoading, setuploadLoading] = useState<boolean>(false);
  // 查看图片
  const [viewPictureDialogShow, setviewPictureDialogShow] = useState<string | undefined>();
  // 身份证头像照片
  const [cardAvatar, setCardAvatar] = useState<string>();
  // 身份证国徽照片
  const [cardNationalEmblem, setNationalEmblem] = useState<string>();
  // 免冠正面照片
  const [handPhoto, setHandPhoto] = useState<string>();
  // 自定义照片
  const [definedPhotoImg, setdefinedPhotoImg] = useState<string>();
  // 已选同意协议
  const [checkProtocol, setCheckProtocl] = useState(false);
  // 显示协议弹窗
  const [showProtocol, setShowProtocol] = useState<string>();

  useEffect(() => {
    let _p = parseLocationParams(location.search) ?? {};
    if (_p.id) {
      getOrderPhotoH5(_p.id);
    }
  }, []); // eslint-disable-line
  async function getOrderPhotoH5(id: string) {
    let res = await apigetOrderPhotoH5(id);
    let data = res.data;
    if (data.code === 200) {
      setdetailData(data?.data);
    } else {
      Toast(data?.msg ?? '获取失败');
    }
  }

  // 上传照片
  const chooseImg = async (t: FileList | null, type: string) => {
    if (t && t[0]) {
      if (t[0].size / 1024 / 1024 > 10) return showToast('照片不可以上传超过10MB');
      setuploadLoading(true);
      try {
        const res = await apiOssUpload(t[0]);
        if (res) {
          if (type === 'cardAvatar') {
            setCardAvatar(res);
          } else if (type === 'cardNationalEmblem') {
            setNationalEmblem(res);
          } else if (type === 'handPhoto') {
            setHandPhoto(res);
          } else if (type === 'definedPhotoImg') {
            setdefinedPhotoImg(res);
          }
        }
      } catch (error) {
      } finally {
        setuploadLoading(false);
      }
    }
  };

  const handleSubmit = async () => {
    if (!cardAvatar) {
      return showToast('请上传身份证人像面');
    }
    if (!cardNationalEmblem) {
      return showToast('请上传身份证国徽面');
    }
    if (!handPhoto) {
      return showToast('请上传免冠人像照');
    }
    if (detailData?.isDefinedPhoto === 'Y' && !definedPhotoImg) {
      return showToast('请上传照片');
    }
    try {
      const res = await apiClientSavePhoto({
        frontPhoto: cardAvatar,
        backPhoto: cardNationalEmblem,
        handPhoto: handPhoto,
        randomNum: detailData?.randomNum,
        definedPhoto: definedPhotoImg,
      });
      let data = res.data;
      if (data.code === 200) {
        navigate(-1);
        showToast(data.msg ?? '操作成功');
      } else {
        showToast(data.msg ?? '操作失败');
      }
    } catch (error) {
      console.log('err', error);
    }
  };

  return (
    <Page
      className="supcertificates-page d-flex-c"
      contentClassName="flex-1 h-1 mb-10 overflow-y"
      appBar={<AppBar title="补传三证" />}
    >
      <div className="p-10 mt-10 bg-white">
        <div className="main-title pos-r ml-4 mb-8 font-size-16 font-widget-600 line-height-24">
          <div className="pos-r zIdx-10">上传身份信息</div>
          <div className="line pos-a l-0"></div>
        </div>
        <div className="text-color-6 font-size-14">根据有关部门要求，必须上传真实身份证照片。</div>
        <span className="text-color-red mb-8 font-size-12">未上传照片，订单无效</span>
        <div className="mt-10">
          <div className="prop-line d-flex-r ai-center">
            <div className="flex-1 pic pb-5 d-flex-r">
              {cardAvatar ? (
                <div className="upload-pic border-radius-4 overflow-hidden mr-5">
                  <img
                    className="bw-100"
                    src={cardAvatar}
                    alt=""
                    onClick={() => setviewPictureDialogShow(cardAvatar)}
                  />
                  <div className="icon-close-block" onClick={() => setCardAvatar(undefined)}>
                    <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                  </div>
                </div>
              ) : (
                <div className={`upload-pic border border-radius-8 text-center d-flex-r ai-center jc-center`}>
                  <div className="flex-1 d-flex-c ai-center jc-center">
                    <img className="w-60 h-60" src="/pic/icon_shoot.png" alt="" />
                    <div className="upload-label font-size-12">
                      拍摄身份证<span className="text-color-p">人像</span>所在面
                    </div>
                  </div>
                  <input
                    className="upload-input bw-100 bh-100"
                    type="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      chooseImg(e.target.files, 'cardAvatar');
                    }}
                  />
                </div>
              )}
              <div className="example-block">
                <img
                  onClick={() => setviewPictureDialogShow('/pic/iccid1.png')}
                  className="example-img"
                  src="/pic/iccid1.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <span className="font-size-12 upload-label">
            手机横拍，保证边角完整信息清晰，不能反光、翻拍、模糊、边角残缺等。
          </span>
        </div>
        <div className="mt-16">
          <div className="prop-line d-flex-r ai-center">
            <div className="flex-1 pic pb-5 d-flex-r">
              {cardNationalEmblem ? (
                <div className="upload-pic border-radius-4 overflow-hidden mr-5">
                  <img
                    className="bw-100"
                    src={cardNationalEmblem}
                    alt=""
                    onClick={() => setviewPictureDialogShow(cardNationalEmblem)}
                  />
                  <div className="icon-close-block" onClick={() => setNationalEmblem(undefined)}>
                    <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                  </div>
                </div>
              ) : (
                <div className={`upload-pic border border-radius-8 text-center d-flex-r ai-center jc-center`}>
                  <div className="flex-1 d-flex-c ai-center jc-center">
                    <img className="w-60 h-60" src="/pic/icon_shoot.png" alt="" />
                    <div className="upload-label font-size-12">
                      拍摄身份证<span className="text-color-p">国徽</span>所在面
                    </div>
                  </div>
                  <input
                    className="upload-input bw-100 bh-100"
                    type="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      chooseImg(e.target.files, 'cardNationalEmblem');
                    }}
                  />
                </div>
              )}
              <div className="example-block">
                <img
                  className="example-img"
                  onClick={() => setviewPictureDialogShow('/pic/iccid2.png')}
                  src="/pic/iccid2.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <span className="font-size-12 upload-label">
            手机横拍，保证边角完整信息清晰，不能反光、翻拍、模糊、边角残缺等。
          </span>
        </div>
        <div className="mt-16">
          <div className="prop-line d-flex-r ai-center">
            <div className="flex-1 pic pb-5 d-flex-r">
              {handPhoto ? (
                <div className="upload-pic border-radius-4 overflow-hidden mr-5">
                  <img className="bw-100" src={handPhoto} alt="" onClick={() => setviewPictureDialogShow(handPhoto)} />
                  <div className="icon-close-block" onClick={() => setHandPhoto(undefined)}>
                    <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                  </div>
                </div>
              ) : (
                <div className={`upload-pic border border-radius-8 text-center d-flex-r ai-center jc-center`}>
                  <div className="flex-1 d-flex-c ai-center jc-center">
                    <img className="w-60 h-60" src="/pic/icon_shoot.png" alt="" />
                    <div className="upload-label font-size-12">拍摄正面免冠人像</div>
                  </div>
                  <input
                    className="upload-input bw-100 bh-100"
                    type="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      chooseImg(e.target.files, 'handPhoto');
                    }}
                  />
                </div>
              )}
              <div className="example-block">
                <img
                  className="example-img"
                  onClick={() => setviewPictureDialogShow('/pic/iccid3.png')}
                  src="/pic/iccid3.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <span className="font-size-12 upload-label">
            请拍摄本人真实环境清晰正面免冠人像，不能反光，有水印，PS、上传证件照等。
          </span>
        </div>

        {/* 上传自定义图片 */}
        {detailData?.isDefinedPhoto === 'Y' && (
          <div className="mt-16">
            <div className="d-flex-r ai-center mb-8">
              <div
                className="upload-pic upload-customize-block customize-block border-radius-8 text-center d-flex-r ai-center jc-center"
                onClick={() => {
                  window.location.href = 'https://getsimnum.caict.ac.cn/m/#/';
                }}
              >
                <div className="flex-1 d-flex-c ai-center jc-center upload-label">
                  <div className="font-size-12 font-widget-600">第一步</div>
                  <img className="w-45 h-45 mt-10 mb-13" src="/pic/icon_search_p.png" alt="" />
                  <div className="font-size-10">查询名下电话卡数量</div>
                </div>
              </div>
              <div className="w-110 prop-line d-flex-r ai-center ml-12">
                <div className="bw-100 h-126 d-flex-r ai-center jc-center">
                  {definedPhotoImg ? (
                    <div className="upload-pic upload-customize border-radius-4 overflow-hidden mr-5">
                      <img
                        className="bw-100"
                        src={definedPhotoImg}
                        alt=""
                        onClick={() => setviewPictureDialogShow(definedPhotoImg)}
                      />
                      <div className="icon-close-block" onClick={() => setdefinedPhotoImg(undefined)}>
                        <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`upload-pic upload-customize-block border border-radius-8 text-center d-flex-r ai-center jc-center`}
                    >
                      <div className="flex-1 d-flex-c ai-center jc-center">
                        <div className="font-size-12 font-widget-600 upload-label">第二步</div>
                        <img className="w-60 h-60 mt-5 mb-5" src="/pic/icon_shoot.png" alt="" />
                        <div className="upload-label font-size-10">上传短信截图</div>
                      </div>
                      <input
                        className="upload-input bw-100 bh-100"
                        type="file"
                        accept=".jpg,.png,.jpeg"
                        onChange={(e) => {
                          chooseImg(e.target.files, 'definedPhotoImg');
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="example-block upload-customize-block">
                <img
                  onClick={() => setviewPictureDialogShow('/pic/iccid4.png')}
                  className="example-img"
                  src="/pic/iccid4.png"
                  alt=""
                />
              </div>
            </div>
            <span className="font-size-12 upload-label">{detailData?.definedPhotoDesc}</span>
          </div>
        )}
        {/* 协议盒子 */}
        <div className="d-flex-r mt-20 bg-white">
          <MCheckbox value={checkProtocol} onChange={(v) => setCheckProtocl(v)} />
          <div className="ml-4 font-size-12">
            <span className="text-color-9" onClick={() => setCheckProtocl(!checkProtocol)}>
              我已阅读并同意
            </span>
            <span className="text-color-p" onClick={() => setShowProtocol('userInfo')}>
              《关于客户个人信息收集、使用规则的公告》
            </span>
            <span className="text-color-p" onClick={() => setShowProtocol('phone')}>
              《办理电话号码开户法律风险及防范提示告知书》
            </span>
          </div>
        </div>
      </div>
      <div
        className="ml-10 mr-10 mt-20 mb-30 bg-p pt-15 pb-15 border-radius-30 text-color-white text-center"
        onClick={handleSubmit}
      >
        上传三证
      </div>
      {/* 查看图片 */}
      {viewPictureDialogShow && (
        <ViewPictureDialog imgPath={viewPictureDialogShow} onClose={() => setviewPictureDialogShow(undefined)} />
      )}
      {uploadLoading && (
        <Loading
          tips={'正在加载中...'}
          loadingClass="bh-100 overflow-hidden text-color-white d-flex-r ai-center jc-center mt-0 bg-shallow"
        />
      )}
      {showProtocol && <ProtocolDialog type={showProtocol} onClose={() => setShowProtocol(undefined)} />}
    </Page>
  );
}
